import React from 'react';

import useRoles from 'src/presentation/components/pages/people/hooks/useRoles';
import useRoutingGroups from 'src/presentation/components/pages/rules/hooks/useRoutingGroups';
import { AttributeMappings } from './AttributeMappings';
import { Row, Section } from 'src/presentation/components/forms/Layout';
import useResource from 'src/presentation/hooks/useResource';
import routingGroupsResource from 'src/actions/routingGroups/routingGroupsResource';
import MappingToSelectorField from './MappingToSelectorField';

const baseAttr = 'idpAttributeMappingsConfig';
const RolesConfig = {
  mappingToFieldName: 'roleIds',
  dropdownPlaceholder: 'Select Roles',
  addButtonLabel: 'Add Role Mapping',
  mappingToColumnLabel: 'Roles',
};
const InboxesConfig = {
  mappingToFieldName: 'routingGroupIds',
  dropdownPlaceholder: 'Select Inboxes',
  addButtonLabel: 'Add Inbox Mapping',
  mappingToColumnLabel: 'Inboxes',
};

export const MappingSection = () => {
  useResource(routingGroupsResource);

  const { roles } = useRoles();
  const { values: routingGroups } = useRoutingGroups();

  const roleOptions = roles.map(role => ({
    label: role.name,
    value: role.id,
  }));

  const routingGroupOptions = routingGroups.map(group => ({
    label: group.label,
    value: group.value,
  }));

  return (
    <Section
      data-aid="idp-attribute-mappings"
      description="Configure how attributes from the Identity Provider are mapped to roles and inboxes in the system."
      header="Identity Provider Attribute Mappings"
      id="idp-attribute-mappings"
    >
      <Row>
        <MappingToSelectorField
          attr={`${baseAttr}.defaultRoles`}
          data-aid={`${baseAttr}.defaultRoles`}
          description="The roles that will be assigned by default."
          label="Default Roles"
          options={roleOptions}
          placeholder={RolesConfig.dropdownPlaceholder}
        />
      </Row>
      <Row>
        <AttributeMappings attr={`${baseAttr}.roleMappings`} options={roleOptions} config={RolesConfig} />
      </Row>
      <Row>
        <MappingToSelectorField
          attr={`${baseAttr}.defaultInboxes`}
          data-aid={`${baseAttr}.defaultInboxes`}
          description="The inboxes that will be assigned by default."
          label="Default Inboxes"
          options={routingGroupOptions}
          placeholder={InboxesConfig.dropdownPlaceholder}
        />
      </Row>
      <Row>
        <AttributeMappings attr={`${baseAttr}.inboxMappings`} options={routingGroupOptions} config={InboxesConfig} />
      </Row>
    </Section>
  );
};
